import React from 'react';
import ListContainer from '../../../components/containers/AdminList';
import { queries } from '../../../graphql/graphql';

const ListContractors: React.FC = () => {
  return (
    <ListContainer
      prefix="contractor"
      query={queries.contractors.CONTRACTORS}
      inline
      editable
      canCreate
      adminView
    />
  );
};

export default ListContractors;
